import { z } from 'zod';
import { t } from 'i18next';
import { ibanIdSchema, moneySchema, taxIdSchema } from '@repo/shared/types';
import { providerType } from '@repo/shared/types';

import { loanFormAgreementsSchema } from './loan-form-agreements.schema';

export const companySchema = z
  .object({
    // eslint-disable-next-line camelcase
    name_surname: z
      .number({
        error: (issue) =>
          issue.input === undefined
            ? t('loanFormPage.borrowerDetails.form.validation.nameSurname')
            : t('loanFormPage.borrowerDetails.form.validation.nameSurname'),
      })
      .nonnegative(),
    mail: z.email({
      error: t('loanFormPage.borrowerDetails.form.validation.mail'),
    }),
    taxId: taxIdSchema,
    bankAccount: ibanIdSchema,
    amount: moneySchema,
    provider: providerType,
    slider: z.number().optional(),
    period: z.string().refine((value) => !isNaN(Number(value))),
    phone: z.string().min(1, t('loanFormPage.borrowerDetails.form.validation.phone')),
    companyName: z.string(),
    documentId: z.string(),
    documentType: z.string().nullish(),
  })
  .extend(loanFormAgreementsSchema.shape);
